import { z } from "zod";

export const AccountPlanSchema = z.object({
  tipoDespesaId: z.string().nullable(),
  valor: z.number().nullable(),
  numPagamento: z.string().nullable(),
});

export type AccountPlanSchemaProps = z.infer<typeof AccountPlanSchema>;
